var React = require('react');
import { withNamespaces } from 'react-i18next';
import Button from 'patternity/lib/button2';

const createTheme = require('patternity/lib/utils/themeable').createTheme;
const Theme = createTheme(window._inflTheme);

const BrandedButton = Theme(Button);

var WelcomeContent = React.createClass({
  propTypes: {
    description: React.PropTypes.string.isRequired,
    clickAction: React.PropTypes.func.isRequired
  },

  render: function() {
    return (
      <section style={styles.welcomeSection} className="onboarding-benefits">
        <div style={styles.description} dangerouslySetInnerHTML={{__html: this.props.description}}>
        </div>
        <div style={styles.action}>
          <BrandedButton type='primary' onClick={this.props.clickAction} classList={'standard-onboarding-welcome-continue-btn'}>
            {this.props.t('Continue')}
          </BrandedButton>
        </div>
      </section>
    );
  }
});

var styles = {
  welcomeSection: {
    margin: '0px 30px 30px 30px'
  },
  description: {
    fontSize: '15px',
    whiteSpace: 'normal',
    margin: '0px auto 30px',
    maxWidth: '900px'
  },
  action: {
    textAlign: 'center'
  }
}

module.exports = withNamespaces()(WelcomeContent);



// WEBPACK FOOTER //
// ./src/advocate/onboarding/components/benefits.jsx